


































import BaseFormEdit from "../../models/base.form.edit";
import { Component } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";

@Component({})
export default class Edit extends BaseFormEdit {
  form = { code: '', name: '', sections: [] } as any;
  created() {
    this.parentValidator.extend("isCodeUnique", this.isCodeUnique);
    this.parentValidator.extend("positiveNumber", this.positiveNumber); 
  }

  get createDate() {
    return moment(String(this.form.createDate)).format("DD.MM.YYYY HH:mm");
  }

  isCodeUnique = {
    validate(value: any, args: any) {
      return axios
        .get("/Services/ValidateCode?code=" + value + "&id=" + args[0])
        .then(response => {
          return response.data;
        })
        .catch(() => {});
    }
  };

  positiveNumber = {
    validate(value: any, args: any) {
      return parseFloat(value) > 0;
    }
  };
}
